<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid' style='padding:0px'>
      <div class='col-lg-12' style='padding:0px'>
        <div class="form-alerts">
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 10px 0px;" v-if='validationErrors'>
          <button type="button" class="close" @click="validationErrors = ''" >&times;</button>
          <ul v-if='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
          </div>
        <!-- <div class="chat-panel panel panel-default"  style="height:400px; overflow-y:auto;"> -->
        <div :class="parseInt(record.payment_type) === 1 ? 'col-lg-12 col-md-12 col-sm-12' : 'col-lg-8 col-md-8 col-sm-8'" style="padding:0px 5px;">
          <div :class="parseInt(record.payment_type) === 1 ? 'col-lg-4 col-md-4 col-sm-4' : 'col-lg-8 col-md-8 col-sm-6'" style='padding:0px 5px;'>
            <div class="form-group input-group" style='margin: 0px'>
              <span class="input-group-addon" style='padding:5px;'>المنتج:</span>
              <select  @change='GetPrice($event)' class="form-control" style="padding: 0px" v-model="record.item_id">
                <option v-for="contractItem in contractItems" v-bind:key="contractItem.id" v-bind:value="contractItem.id">
                  {{ contractItem.item }}
                </option>
              </select>
            </div>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding:0px 5px;'>
            <div class="form-group input-group" style='margin: 0px'>
              <span class="input-group-addon" style='padding:5px;'>طريقة الدفع:</span>
              <select :disabled ="parseInt(record.id) !== 0" @change='GetPrice($event);changePayEmptyInstallments()' class="form-control" style="padding: 0px" v-model="record.payment_type">
                <option v-for="type in paymentTypes" v-bind:key="type.id" v-bind:value="type.id">
                  {{ type.name }}
                </option>
              </select>
            </div>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding:5px;'>
            <label v-if="parseInt(record.payment_type) !== 1">&nbsp;</label>
            <div class="form-group input-group" style='margin: 0px'>
              <span class="input-group-addon" style='padding:5px;'>حالة المنتج:</span>
              <select  @change='GetPrice($event)' class="form-control" style="padding: 0px" v-model="record.item_type">
                <option v-for="type in itemTypes" v-bind:key="type.id" v-bind:value="type.id">
                  {{ type.name }}
                </option>
              </select>
            </div>
          </div>
          <div :class="parseInt(record.payment_type) === 1 ? 'col-lg-2 col-md-2 col-sm-2' : 'col-lg-4 col-md-4 col-sm-6'" style='padding:5px;'>
            <label>تاريخ العقد:</label>
            <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.contract_date'></Datepicker>
          </div>
          <div :class="parseInt(record.payment_type) === 1 ? 'col-lg-2 col-md-2 col-sm-2' : 'col-lg-4 col-md-4 col-sm-6'" style='padding:5px;'>
            <label>تاريخ التركيب:</label>
            <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.installtion_date'></Datepicker>
          </div>
          <div :class="parseInt(record.payment_type) === 1 ? 'col-lg-4 col-md-4 col-sm-4' : 'col-lg-6 col-md-6 col-sm-6'" style='padding:5px;'>
            <label v-if="parseInt(record.payment_type) === 1">&nbsp;</label>
            <div class="form-group input-group" style='margin: 0px'>
              <span class="input-group-addon" style='padding:5px;'>المفوض:</span>
              <select class="form-control" style="padding: 0px" v-model="record.delegate_id">
                <option
                v-for="u in delegates"
                :key="u.id"
                :value="u.id"
                >
                {{ u.name }}
              </option>
            </select>
            </div>
        </div>
        <div :class="parseInt(record.payment_type) === 1 ? 'col-lg-4 col-md-4 col-sm-4' : 'col-lg-6 col-md-6 col-sm-6'" style='padding:5px;'>
          <label v-if="parseInt(record.payment_type) === 1">&nbsp;</label>
          <div class="form-group input-group" style='margin: 0px'>
            <span class="input-group-addon" style='padding:5px;'>الفنى:</span>
            <select class="form-control" style="padding: 0px" v-model="record.technical_id">
              <option
              v-for="u in technicals"
              :key="u.id"
              :value="u.id"
              >
              {{ u.name }}
            </option>
          </select>
          </div>
      </div>
      <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
        <label>حالة العقد:</label>
        <select class="form-control" style="padding: 0px" v-model="record.status">
          <option v-for="item in status" v-bind:key="item.id" v-bind:value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
        <label>السعر:</label>
        <input  readonly  autocomplete="off"   onpaste="return false;"   ondrop="return false;"   style="ime-mode:disabled;" v-model='record.price' class='form-control' name='price' type='text'>
      </div>
      <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
        <label>مصاريف التركيب:</label>
        <input  @keypress="isNumber($event)"  v-on:input="UpdatePrice()" v-model='record.installation_fee' class='form-control' name='installation_fee' type='text'>
      </div>
      <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
        <label>قيمة الخصم:</label>
        <input  @keypress="isNumber($event)"  v-on:input="UpdatePrice()" v-model='record.discount' class='form-control' name='discount' type='text'>
      </div>
      <div :class="parseInt(record.payment_type) === 1 ? 'col-lg-3 col-md-3 col-sm-3' : 'col-lg-6 col-md-6 col-sm-6'" style='padding:5px;'>
        <div class="form-group input-group" style='margin: 0px'>
          <span class="input-group-addon" style='padding:5px;'>المبلغ {{txtCaption}}:</span>
          <input  disabled  autocomplete="off"   onpaste="return false;"   ondrop="return false;"   style="ime-mode:disabled;"  v-model='record.amount' class='form-control' name='amount' type='text'>
        </div>
      </div>
      <div :class="parseInt(record.payment_type) === 1 ? 'col-lg-4 col-md-4 col-sm-4' : 'col-lg-6 col-md-6 col-sm-6'" style='padding:5px;'>
        <div class="form-group input-group" style='margin: 0px'>
          <span class="input-group-addon" style='padding:5px;'>بداية عقد الصيــانــة:</span>
          <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.maintenance_date'></Datepicker>
        </div>
      </div>
      <div :class="parseInt(record.payment_type) === 1 ? 'col-lg-5 col-md-5 col-sm-5' : 'col-lg-12 col-md-12 col-sm-12'" style='padding:5px;'>
        <div class="form-group input-group" style='margin: 0px'>
          <span class="input-group-addon" style='padding:5px;'>الشمع المجانى:</span>
          <select :disabled ="parseInt(record.id) !== 0" @change="setFreeItemsModal(record.free_offer_id)" class="form-control" style="padding: 0px" v-model="record.free_offer_id">
            <option v-for="type in free_offers" v-bind:key="type.id" v-bind:value="type.id">
              {{ type.offer_name }}
            </option>
          </select>
          <span v-if = "parseInt(record.id) === 0" class="input-group-btn">
            <button class="btn btn-default" @click="OpenFreeItemsModal(record.free_offer_id)" type="button"><i class="fa fa-list-alt"></i></button>
          </span>
        </div>
      </div>
      <div v-if="parseInt(record.payment_type) === 2" class='col-lg-6' style='padding:5px;'>
        <div class="form-group input-group" style='margin: 0px'>
          <span class="input-group-addon" style='padding:5px;'>المقـــــــــــــــدم:</span>
          <input @keypress="isNumber($event)" v-on:input="UpdatePrice()" v-model='record.presenter' class='form-control' name='presenter' type='text'>
        </div>
      </div>
      <div v-if="parseInt(record.payment_type) === 2" class='col-lg-6 col-md-6 col-sm-6' style='padding:5px;'>
        <div class="form-group input-group" style='margin: 0px'>
          <span class="input-group-addon" style='padding:5px;'>تاريـخ سداد المقدم:</span>
          <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.presenter_date'></Datepicker>
          <span class="input-group-btn">
            <button class="btn btn-default" @click="inputEmpty()" type="button" style = "color: red;">X</button>
          </span>
        </div>
      </div>
      <div v-if="parseInt(record.payment_type) === 2" class='col-lg-6 col-md-6 col-sm-6' style='padding:5px;'>
        <div class="form-group input-group" style='margin: 0px'>
          <span class="input-group-addon" style='padding:5px;'>الباقــــــــــــــــى:</span>
          <input  @keypress="isLocked($event)" v-model='record.rest' class='form-control' name='rest' type='text'>
        </div>
      </div>
      <div v-if="parseInt(record.payment_type) === 2" class='col-lg-6 col-md-6 col-sm-6' style='padding:5px;'>
        <div class="form-group input-group" style='margin: 0px'>
          <span class="input-group-addon" style='padding:5px;'>تــاريـــــخ أول قســـط:</span>
          <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.instal_start'></Datepicker>
        </div>
      </div>
      <div v-if="parseInt(record.payment_type) === 2" class='col-lg-6 col-md-6 col-sm-6' style='padding:5px;'>
        <div class="form-group input-group" style='margin: 0px'>
          <span class="input-group-addon" style='padding:5px;'>عدد الأقساط:</span>
          <select class="form-control" style="padding: 0px" v-model="record.instal_count">
            <option v-for="n in 18" :key="n" :value="n">
              {{ n }}
            </option>
          </select>
        </div>
      </div>
      <div v-if="parseInt(record.payment_type) === 2" class='col-lg-6 col-md-6 col-sm-6' style='padding:5px;'>
        <div class="form-group input-group" style='margin: 0px'>
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" @click="calcInstallment();"><i class="fa fa-keyboard-o" style = "color: blue;"></i>
            </button>
          </span>
          <span class="input-group-addon" style='padding:5px;'>قيمة القسط:</span>
          <input maxlength="4" @keypress="isNumber($event)" v-model='record.instal_amount' class='form-control text-center' name='installment' type='text'>
        </div>
      </div>
    </div>
    <!-- *************************************************************************** -->
    <!-- ======================= Add Modale Start -->
    <InstallmentsModal
      v-if="parseInt(record.payment_type) === 2"
      :rest="record.rest"
      :instal-count="record.instal_count"
      :instal-amount="record.instal_amount"
      :instal-start="record.instal_start"
      :installments="installments"
      :treasuries= "treasuries"
      :technicals= "technicals"
      @return-data="changeBlance"
      ref="installments"
    />
    <!-- ======================= Add Modale End -->

      <div class='col-lg-12 col-sm-12'>
        <label>ملاحظات:</label>
        <textarea class="form-control" rows="2" v-model="record.nots"></textarea>
      </div>
      <div>
        <div class='col-lg-6 col-md-6 col-sm-6' style='padding:10px 20px 0px 5px;'>
          <button v-show="($per.value.saveContract && record.id === 0 ) || ($per.value.editContract && record.id > 0 )" @click='saveData()'  type='button' class='btn btn-block btn-md btn-success'> <i class="fa fa-save"></i> <b>حفظ</b> </button>
        </div>
        <div class='col-lg-6 col-md-6 col-sm-6' style='padding:10px 5px 0px 20px;'>
          <button v-show="$per.value.deleteContract && record.id > 0"  @click='deleteData()' type='button' class='btn btn-block btn-danger btn-md'> <i class="fa fa-trash"></i> <b>حذف</b> </button>
        </div>
      </div>
      <div class="col-lg-12" style="text-align: center">
        <code>{{ recordMetaInfo }}</code>
      </div>
  <!-- </div> -->
  </div>
  <!-- /.col-lg-12 -->

</div>
<!-- /.container-fluid -->
<!-- ======================= Free Items Modale Start -->
<div v-if="showFreeItemsModal" class="custom-centered-modal">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" @click="showFreeItemsModal = false">&times;</button>
        <h4 class="modal-title text-center">الشمع المجانى مع العقد</h4>
      </div>

      <div class="modal-body">
        <table class="table table-bordered table-striped">
            <thead>
                <tr>
                    <th style="width: 50px;">#</th>
                    <th style="text-align:center;">الصنف</th>
                    <th style="width: 120px; text-align:center;">تم التسليم</th>
                    <th style="width: 120px; text-align:center;">تم التركيب</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in record.free_offer_items" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.item }}</td>
                    <td class="text-center">
                    <label class="switch">
                      <input type="checkbox" v-model="item.delivered" >
                      <span class="slider round"></span>
                    </label>
                  </td>
                    <td class="text-center">
                      <label class="switch">
                        <input type="checkbox" v-model="item.changed" >
                        <span class="slider round"></span>
                      </label>
                    </td>
                </tr>

                <tr v-if="record.free_offer_items.length === 0">
                    <td colspan="4" class="text-center text-muted">
                        لا يوجد أصناف
                    </td>
                </tr>
            </tbody>
        </table>
      </div>

      <div class="modal-footer">
        <button @click="showFreeItemsModal = false" type='button' class='btn btn-outline btn-sm btn-default'>إغلاق</button>
      </div>
    </div>
  </div>
</div>
<!-- ======================= Free Items Modale End -->
</div>
</template>
<script>
import InstallmentsModal from './contractModale/InstallmentsModal.vue'
import API from '@/store/api'
import Datepicker from 'vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import Swal from 'sweetalert2'
export default {
  // **************************************************************************
  components: {
    Datepicker,
    InstallmentsModal
  },
  // **************************************************************************
  name: 'Contracts',
  // **************************************************************************
  computed: {
    recordMetaInfo () {
      if (!this.record) return ''
      const created = this.formatDateTime(this.record.created_at)
      const updated = this.formatDateTime(this.record.updated_at)
      const user = this.record.user_name || ''
      return `تاريخ الانشاء ${created} | آخر تعديل ${updated} | بواسطة: ${user}`
    }
  },
  // **************************************************************************
  watch: {
    'record.free_offer_items': {
      deep: true,
      handler (items) {
        if (!Array.isArray(items)) return
        items.forEach(item => {
          if (item.changed && !item.delivered) {
            item.delivered = true
          }
          if (!item.delivered && item.changed) {
            item.changed = false
          }
        })
      }
    }
  },
  // =========================================================================
  data () {
    return {
      txtCaption: 'المطلوب',
      dateContractTitle: 'تاريخ العقد',
      dateInstallationTitle: 'تاريخ التركيب',
      dateMaintanenceTitle: 'بداية عقد الصيانة',
      customPremiumDateTitle: 'ت سداد مخصص',
      ar: ar,
      validationErrors: '',
      record: {},
      technicals: [],
      delegates: [],
      treasuries: [],
      free_offers: {},
      contractItems: [],
      maintenanceGroups: {},
      emptyRec: [{id: 0, name: ''}],
      paymentTypes: [{id: 1, name: 'كاش'}, {id: 2, name: 'قسط'}],
      itemTypes: [{id: 0, name: 'جديد'}, {id: 1, name: 'استبدال'}],
      status: [{id: 1, name: 'نشط'}, {id: 0, name: 'غير نشط'}, {id: 2, name: 'ممتنع'}, {id: 3, name: 'قضية'}, {id: 4, name: 'مرتجع'}],
      items: [],
      installments: [],
      isLoadingData: false,
      uid: '',
      showFreeItemsModal: false,
      newRecord: {
        'id': 0,
        'item_id': '',
        'customer_id': '',
        'item_type': 0,
        'delegate_id': '',
        'technical_id': '',
        'contract_date': '',
        'installtion_date': '',
        'maintenance_date': '',
        'price': 0,
        'amount': 0,
        'discount': 0,
        'installation_fee': 0,
        'presenter': 0,
        'rest': 0,
        'instal_count': '',
        'instal_amount': '',
        'instal_start': '',
        'presenter_date': '',
        'contract_type': 1,
        'status': 1,
        'nots': '',
        'free_offer_id': null,
        'free_offer_reference': null,
        'free_offer_items': [],
        'payment_type': 1
      }
    }
  },
  mounted () {
    document.addEventListener('keydown', this.handleEscape)
  },
  // ===========================================================================
  beforeDestroy () {
    document.removeEventListener('keydown', this.handleEscape)
  },
  // ===========================================================================
  methods: {
    onInstallmentModalClose () {

    },
    // ===========================================================================
    closeModal () {
      this.showFreeItemsModal = false
      this.showInstallmentPayModal = false
    },
    // ===========================================================================
    handleEscape (event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.closeModal()
      }
    },
    // ===========================================================================
    formatDateTime (dateStr) {
      if (!dateStr) return ''

      const d = new Date(dateStr)

      let hours = d.getHours()
      const minutes = d.getMinutes().toString().padStart(2, '0')
      const day = d.getDate().toString().padStart(2, '0')
      const month = (d.getMonth() + 1).toString().padStart(2, '0')
      const year = d.getFullYear()

      const isPM = hours >= 12
      const suffix = isPM ? 'م' : 'ص'

      hours = hours % 12
      hours = hours === 0 ? 12 : hours
      hours = hours.toString().padStart(2, '0')

      return `${year}/${month}/${day} ${hours}:${minutes}${suffix}`
    },
    // -----------------------------------------------------------------------
    async pageLoad (id, branch, isHaveContract) {
      this.installments = []
      this.delegates = branch.delegates
      this.technicals = branch.technicals
      this.treasuries = branch.treasuries
      this.contractItems = branch.items.filter(item => parseInt(item.is_contract) === 1)
      this.maintenanceGroups = branch.maintenance_groups
      this.free_offers = branch.offers.filter(item => parseInt(item.type) === 0)
      this.items = branch.items
      this.isLoadingData = true
      if (isHaveContract === 0) {
        this.record = JSON.parse(JSON.stringify(this.newRecord))
        this.installments = []
      } else {
        try {
          const data = await API.getCustomerContract({
            id: id
          })
          if (data.data.length === 0) {
            this.record = JSON.parse(JSON.stringify(this.newRecord))
          } else {
            this.record = data.data
          }
          this.installments = JSON.parse(JSON.stringify(data.installments))
        } catch (err) {
          this.record = null
        }
      }
      this.delegates = this.injectIfMissing(
        this.delegates,
        this.record.delegate_id,
        this.record.delegate_name
      )
      this.technicals = this.injectIfMissing(
        this.technicals,
        this.record.technical_id,
        this.record.technical_name
      )
      // -----------------------------
      if (this.record.maintenance_date) {
        this.record.maintenance_date = moment(this.record.maintenance_date).format('YYYY-MM-DD')
      }
      // -----------------------------
      if (this.record.presenter_date) {
        this.record.presenter_date = moment(this.record.presenter_date).format('YYYY-MM-DD')
      }
      // -----------------------------
      if (this.record.presenter_date) {
        this.record.presenter_date = moment(this.record.presenter_date).format('YYYY-MM-DD')
      }
      // -----------------------------
      if (this.record.instal_start) {
        this.record.instal_start = moment(this.record.instal_start).format('YYYY-MM-DD')
      }
      // -----------------------------
      if (this.record.installtion_date) {
        this.record.installtion_date = moment(this.record.installtion_date).format('YYYY-MM-DD')
      }
      // -----------------------------
      if (this.record.contract_date) {
        this.record.contract_date = moment(this.record.contract_date).format('YYYY-MM-DD')
      }
      // -----------------------------
      this.txtCaption = this.record.payment_type === 1 ? 'المسدد' : 'المطلوب'
      this.isLoadingData = false
      this.uid = id
      this.record.uid = id
    },
    // ============================================================
    injectIfMissing (list, id, name) {
      if (!id) return list
      const exists = list.some(u => u.id === id)
      if (exists) return list
      list.unshift({
        id: id,
        name: `❌ ${name || 'غير موجود'}`,
        is_missing: true
      })
      return list
    },
    // ============================================================
    changePayEmptyInstallments () {

    },
    // ============================================================
    calcInstallment () {
      if ((this.record.instal_count || 0) > 0) {
        this.record.instal_amount = Math.floor((this.record.rest || 0) / (this.record.instal_count || 0))
      } else {
        this.record.instal_amount = 0
      }
    },
    // ============================================================
    setFreeItemsModal (id) {
      if (id === null || id === undefined) return
      let i = this.free_offers.map(record => record.id).indexOf(id)
      if (i > -1) {
        this.record.free_offer_items = this.free_offers[i].offer_items.flatMap(item =>
          Array.from({ length: item.item_pieces }, () => ({
            item_id: item.item_id,
            item: item.item,
            delivered: false,
            changed: false
          }))
        )
      }
      this.OpenFreeItemsModal(id)
    },
    // ============================================================
    OpenFreeItemsModal (id) {
      if (id === null || id === undefined) {
        Swal.fire({
          position: 'fixed',
          icon: 'error',
          title: 'عفوا يرجى اختيار الشمع المجانى أولاً',
          showConfirmButton: false,
          timer: 3000
        })
        return
      }
      if (this.record.free_offer_items.length === 0) {
        let i = this.free_offers.map(record => record.id).indexOf(id)
        if (i > -1) {
          this.record.free_offer_items = this.free_offers[i].offer_items.map(item => ({
            item_id: item.item_id,
            item: item.item,
            delivered: false,
            changed: false
          }))
        }
      }
      this.showFreeItemsModal = true
    },
    // =========================================================================
    inputEmpty (id) {
      this.record.presenter_date = null
    },
    // =====================================================
    GetPrice () {
      let i = this.items.findIndex(x => parseInt(x.id) === parseInt(this.record.item_id))
      if (i > -1) {
        if (this.record.payment_type === 1) {
          this.record.price = this.items[i].price
        } else {
          this.record.price = this.items[i].installment_price
        }
      } else {
        this.record.price = 0
      }
      this.UpdatePrice()
    },
    // ============================================================
    UpdatePrice () {
      this.record.amount = (parseInt(this.record.price || 0) + parseInt(this.record.installation_fee || 0)) - parseInt(this.record.discount || 0)
      if (this.record.payment_type === 1) {
        this.record.presenter = this.record.amount
        this.record.rest = 0
        this.record.presenter_date = null
        this.record.instal_start = null
        this.record.instal_count = null
        this.record.instal_amount = null
        this.txtCaption = 'المسدد'
        this.installments = []
      } else {
        this.record.rest = this.record.amount - parseInt(this.record.presenter || 0)
        this.txtCaption = 'المطلوب'
      }
    },
    // ============================================================
    async saveData () {
      this.validationErrors = []
      var isError = false
      // ------------------------------------------------
      const id = Number(this.record.item_id)
      if (!Number.isInteger(id) || id < 1) {
        this.validationErrors.push('يجب اختيار المنتج')
        isError = true
      }
      // -------------------------------
      if (!moment(this.record.contract_date, 'YYYY-MM-DD', true).isValid()) {
        this.validationErrors.push('يجب ادخال تاريخ التعاقد')
        isError = true
      }
      // -------------------------------
      // if (!moment(this.record.installtion_date, 'YYYY-MM-DD', true).isValid()) {
      //   this.validationErrors.push('يجب ادخال تاريخ التركيب')
      //   isError = true
      // }
      // -------------------------------
      if (parseInt(this.record.free_offer_id) > 0) {
        if (!moment(this.record.maintenance_date, 'YYYY-MM-DD', true).isValid()) {
          this.validationErrors.push('يجب إدخال تاريخ بداية عقد الصيانة')
          isError = true
        }
      }
      // -------------------------------
      if (parseInt(this.record.payment_type) === 2) {
        if (parseInt(this.record.amount) < 0) {
          this.validationErrors.push('عفوا المطلوب يجب ان يكون قيمة موجبة')
          isError = true
        }
        if (parseInt(this.record.presenter) >= parseInt(this.record.amount)) {
          this.validationErrors.push('يجب ان يكون المقدم اقل من المطلوب فى العقود القسط')
          isError = true
        }
        if (parseInt(this.record.rest) <= 0) {
          this.validationErrors.push('عفوا المبلغ المتبقى يجب ان يكون أكبر من صفر')
          isError = true
        }
        // -------------------------------
        if (moment(this.record.presenter_date, 'YYYY-MM-DD', true).isValid()) {
          if (parseInt(this.record.presenter) === 0 || this.record.presenter === null || this.record.presenter === '') {
            this.validationErrors.push('يجب ادخال المبلغ المقدم او حذف تاريخ  سداد المقدم')
            isError = true
          }
        }
        // -------------------------------
        if (parseInt(this.record.presenter) > 0) {
          if (!moment(this.record.presenter_date, 'YYYY-MM-DD', true).isValid()) {
            this.validationErrors.push('يجب اختيار تاريخ سداد المقدم')
            isError = true
          }
        }
        // -------------------------------
        if (!moment(this.record.instal_start, 'YYYY-MM-DD', true).isValid()) {
          this.validationErrors.push('يجب اختيار تاريخ أول قسط')
          isError = true
        }
        // -------------------------------
        if (parseInt(this.record.instal_count) === 0 || this.record.instal_count === null || this.record.instal_count === '') {
          this.validationErrors.push('يجب اختيار عدد الاقساط')
          isError = true
        }
        // -------------------------------
        if (parseInt(this.record.instal_amount) === 0 || this.record.instal_amount === null || this.record.instal_amount === '') {
          this.validationErrors.push('يجب ادخال قيمة القسط')
          isError = true
        }
        // -------------------------------
        if (parseInt(this.record.instal_amount) > parseInt(this.record.rest)) {
          this.validationErrors.push('يجب ان يكون قيمة القسط اقل من المبلغ الباقى')
          isError = true
        }
        // -------------------------------
      } else {
        if (parseInt(this.record.amount) < 0) {
          this.validationErrors.push('عفوا المسدد يجب ان يكون قيمة موجبة او صفر')
          isError = true
        }
      }
      const inst = this.$refs.installments

      // تحقق من الأقساط فقط لو الكمبوننت موجود
      if (inst && inst.installmentsDiff !== 0) {
        this.validationErrors.push('خطأ فى احتساب الأقساط')
        isError = true
      }

      if (isError === true) {
        return
      }

      this.validationErrors = ''

      // ======================================================
      // تجهيز الأقساط
      // ======================================================

      const installmentsPayload = inst
        ? inst.prepareInstallmentsPayload()
        : { newInstallments: [], updatedInstallments: [], deletedInstallments: [] }

      // ======================================================
      // تجهيز الداتا للحفظ
      // ======================================================

      const savedData = {
        ...this.record,
        installments: installmentsPayload
      }

      this.isLoadingData = true
      try {
        const data = await API.saveCustomerContract(savedData)
        this.$emit('return-data', data.totals.balance, data.data.customer_id)
        this.record = data.data
        this.record.uid = this.uid
        this.installments = JSON.parse(JSON.stringify(data.installments))
        if (this.record.maintenance_date) {
          this.record.maintenance_date = moment(this.record.maintenance_date).format('YYYY-MM-DD')
        }
        if (this.record.presenter_date) {
          this.record.presenter_date = moment(this.record.presenter_date).format('YYYY-MM-DD')
        }
        if (this.record.instal_start) {
          this.record.instal_start = moment(this.record.instal_start).format('YYYY-MM-DD')
        }
        if (this.record.installtion_date) {
          this.record.installtion_date = moment(this.record.installtion_date).format('YYYY-MM-DD')
        }
        if (this.record.contract_date) {
          this.record.contract_date = moment(this.record.contract_date).format('YYYY-MM-DD')
        }
        Swal.fire({
          position: 'fixed',
          icon: 'success',
          title: 'تم الحفظ بنجاح',
          showConfirmButton: false,
          timer: 1000
        })
      } catch (err) {
        this.validationErrors = err.errors
      }
      this.isLoadingData = false
    },
    // =====================================================
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // =====================================================
    isLocked: function (evt) {
      evt.preventDefault()
    },
    // =====================================================
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    // =====================================================
    changeBlance (balanceVlaue, rec) {
      this.$emit('return-data', balanceVlaue, rec)
    },
    // =====================================================
    async deleteData () {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا السجل نهائيا من قاعدة البيانات!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.isLoadingData = true
            try {
              const data = await API.deleteCustomerContract({
                id: this.uid
              })
              this.$emit('return-data', Number(data.blance), data.id)
              this.record = JSON.parse(JSON.stringify(this.newRecord))
              this.installments = []
              Swal.fire({
                position: 'fixed',
                icon: 'success',
                title: 'تم الحذف بنجاح',
                showConfirmButton: false,
                timer: 1000
              })
            } catch (err) {
              this.record = null
            }
            this.isLoadingData = false
          }
        })
    }
    // =====================================================
  }
}
</script>
<style>
  .highlight {
     background-color: #5A9EF5;
  }
  tr:hover{
     cursor: pointer;
  }
  /* The switch - the box around the slider */
  .switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
  }

  /* Hide default HTML checkbox */
  .switch input {
  opacity: 0;
  width: 0;
  height: 0;
  }

  /* The slider */
  .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
  }

  .slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
  }

  input:checked + .slider {
  background-color: #2196F3;
  }

  input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
  }

  input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
  }

  /* Rounded sliders */
  .slider.round {
  border-radius: 17px;
  }

  .slider.round:before {
  border-radius: 50%;
  }
  .text-red {
      color: #a94442 !important;
      font-weight: bold;
  }
  .custom-centered-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1050;
    background: rgba(0,0,0,0.4); /* خلفية شفافة اختيارية */
    width: 100%;
    height: 100%;
  }

  .modal-dialog-centered {
    margin: 0 auto;
  }
  .text-red {
    color: red;
  }
  .text-green {
    color: green;
  }
  .red-strikethrough {
    color: red;
    text-decoration: line-through;
  }
  .compact-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px; /* حجم خط صغير */
  }

  .compact-table th,
  .compact-table td {
    border: 1px solid #ccc;
    padding: 2px 4px; /* تقليل padding */
    text-align: center;
  }

  .compact-table th {
    background-color: #f2f2f2;
    font-weight: bold;
  }

  .compact-table tr {
    height: 25px; /* تقليل ارتفاع الصف */
  }
  .form-alerts {
    position: sticky;
    top: 0;
    z-index: 5;
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sales/Customers/Contracts.vue